let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6AfiL")).then(() => parcelRequire('3T5bx'));